export default __webpack_public_path__ + "static/media/ridezz.11d99025.svg";